import { render, staticRenderFns } from "./SignUp.html?vue&type=template&id=0da4f3f0&scoped=true&"
import script from "./SignUp.js?vue&type=script&lang=js&"
export * from "./SignUp.js?vue&type=script&lang=js&"
import style0 from "./SignUp.scss?vue&type=style&index=0&id=0da4f3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da4f3f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow,VTextField})
